
import { useEffect, useRef } from 'preact/hooks'

export function useDidMountEffect(func, deps) {
    const didMount = useRef(false)
    useEffect(() => {
        if (didMount.current) func()
        didMount.current = true
    }, deps)
}